<template>
  <div class="redes" :class="theme">
    <div class="redes-wrapper">
      <a
        :href="links.linkFace"
        class="face-share-button"
        title="Compartilo en Facebook"
      ></a>
      <a
        :href="links.linkX"
        class="twi-share-button"
        title="Compartilo en X"
      ></a>
      <a
        :href="links.linkIG"
        class="ig-share-button"
        title="Compartilo por Instagram"
      ></a>
      <a
        :href="links.linkYouT"
        class="yout-share-button"
        title="Compartilo por Youtube"
      ></a>
    </div>
  </div>
</template>

<script>
////////////// redes //////////////
export default {
  name: "Redes",
  props: {
    links: {
      type: Object,
      required: true
    },
    textoRedes: {
      required: false
    },
    hashtag: {
      required: false
    },
    isDark: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      theme: {
        "btn-light": !this.isDark,
        "btn-dark": this.isDark
      }
    }
  },
  computed: {
    urlNota() {
      const urlNota = location.href
      return encodeURIComponent(urlNota)
    },
    notaId() {
      const startId = this.urlNota.indexOf("nid") + 3
      return this.urlNota.substring(startId)
    }
  },
  methods: {
    shareWH() {
      const urlShare = `https://api.whatsapp.com/send?text=${this.textoRedes} --> ${this.urlNota}`
      window.open(urlShare, "_blank")
    },
    shareTW() {
      const urlShare = `https://twitter.com/share?url=${this.urlNota}&text=${
        this.textoRedes
      }&hashtags=${this.hashtag || ""}&via=lanacion&size=large`
      window.open(urlShare, "_blank", "width=555,height=400")
    },
    shareFB() {
      const urlShare = `https://www.facebook.com/sharer/sharer.php?u=${this.urlNota}`
      window.open(urlShare, "_blank", "width=555,height=400")
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/_variables.scss";

#appContainer {
  /*redes*/

  .redes {
    position: relative;
    display: flex;
    justify-content: center;
    margin: 30px 0;
    // margin-top: 20px;

    &.top {
      position: relative;
      margin: 0 auto;
      width: 192px;
    }

    // @media (max-width: 640px) {
    //   top: -3px;
    //   right: calc(35% - 190px);
    // }
    // @media (max-width: 500px) {
    //   top: -3px;
    //   right: calc(42% - 190px);
    // }
    // @media (max-width: 400px) {
    //   top: -3px;
    //   right: calc(52% - 190px);
    // }

    &.btn-light, &.btn-dark{
      @media screen and (max-width: 600px) {
        margin: 30px 0 10px;
      }
      a {
        display: inline-block;
        width: 35px;
        height: 35px;
        // border-radius: 50%;
        cursor: pointer;
        margin: 0 0.4rem;
        background-repeat: no-repeat;
        background-size: 140px;
        // border: 1px solid #000;
        // background-position: 0px 0px;
        background-image: url('../assets/redes.png');
        @media screen and (max-width: 400px) {
          margin: 0 3px;
        }
  
        &.face-share-button {
          background-position: 0px 0px;
        }
  
        &.twi-share-button {
          background-position: -30px 1px;
          @media screen and (max-width: 600px) {
            background-position: -26px 1px;
          }
        }
  
        &.ig-share-button {
          background-position: -65px 1px;
          @media screen and (max-width: 600px) {
            background-position: -56px 1px;
          }
        }
        &.yout-share-button {
          background-position: -103px 1px;
          @media screen and (max-width: 600px) {
            background-position: -88px 1px;
          }
        }
        
        &:hover {
            // opacity: 0.5;
            // background-color: var(--white);
          &.face-share-button {
            background-position: 0px -30px;
          }
    
          &.twi-share-button {
            background-position: -30px -30px;
          }
    
          &.ig-share-button {
            background-position: -65px -30px;
          }
          &.yout-share-button {
            background-position: -103px -30px;
          }
        }
        @media screen and (max-width: 600px) {
            background-size: 120px;
            width: 30px;
            height: 30px;
        }
      }
    }
    &.btn-dark{
      @media screen and (max-width: 600px) {
        margin: 30px 0;
      }
      a {
        &.face-share-button {
            background-position: 0px -30px;
            @media screen and (max-width: 600px) {
              background-position: 0px -26px;
            }
          }
    
          &.twi-share-button {
            background-position: -30px -30px;
            @media screen and (max-width: 600px) {
              background-position: -26px -26px;
            }
          }
    
          &.ig-share-button {
            background-position: -65px -30px;
            @media screen and (max-width: 600px) {
              background-position: -56px -26px;
            }
          }
          &.yout-share-button {
            background-position: -103px -30px;
            @media screen and (max-width: 600px) {
              background-position: -88px -26px;
            }
          }
          &:hover{
            // opacity: 0.5;
            // background-color: var(--black);
            &.face-share-button {
              background-position: 0px -62px;
            }
      
            &.twi-share-button {
              background-position: -30px -62px;
            }
      
            &.ig-share-button {
              background-position: -65px -61px;
            }
            &.yout-share-button {
              background-position: -103px -61px;
            }
          }
      }
    }
  }

  // .redes.btn-blancos a {
  //   // background-color: white;
  //   // filter: hue-rotate(100deg) invert(0.8);
  //   background-image: url(~@/assets/redes.svg);
  //   opacity: 1;
  //   background-color: white;
  //   transition: all 200ms;
  //   &:hover {
  //     opacity: 0.6;
  //   }
  // }
  // .redes.btn-negros a {
  //   background-color: var(--col-text);
  //   background-image: url(https://buckets3.glanacion.com/lntools/anexos/fotos/16/15416.svg);
  //   opacity: 1;
  //   border: 1px solid white;
  //   transition: all 200ms;
  //   &:hover {
  //     opacity: 0.6;
  //   }
  // }
}
</style>
